import { render, staticRenderFns } from "./home-nav.vue?vue&type=template&id=5784fae5&"
import script from "./home-nav.vue?vue&type=script&lang=js&"
export * from "./home-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5784fae5')) {
      api.createRecord('5784fae5', component.options)
    } else {
      api.reload('5784fae5', component.options)
    }
    module.hot.accept("./home-nav.vue?vue&type=template&id=5784fae5&", function () {
      api.rerender('5784fae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/home-nav.vue"
export default component.exports